export { default as PayAnyoneLanding } from './Pay/PayAnyoneLanding';
export { default as ReturnUserLanding } from './ReturnUser/ReturnUserLanding';
export { default as ReceiveFromAnyoneLanding } from './Request/ReceiveFromAnyoneLanding';
